export default "__VITE_ASSET__DedDa4n2__"